import { exists } from '@/api'

export interface BatchReminderLetterConditionListItem {
  returnPlansDateFrom: string
  returnPlansDateTo: string
  dunningDateFrom: string
  dunningDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  radioBranchType: string
  radioUserType: string
  userCodeFrom: string
  userCodeTo: string
  radioUpdate: string
  isOrderTelInclude: boolean
  isNotLostCollection: boolean
  isNotLostProcedure: boolean
  isRsvCollection: boolean
  isOtherDunningDoc: boolean
  isMailApplicant: boolean
  batchType: string
}

export function BatchReminderListConditionLetterItemFromJSON(
  json: any
): BatchReminderLetterConditionListItem {
  const resp = JSON.parse(json)

  return {
    returnPlansDateFrom: exists(resp, 'return_plans_date_from')
      ? resp.return_plans_date_from
      : '',
    returnPlansDateTo: exists(resp, 'return_plans_date_to')
      ? resp.return_plans_date_to
      : '',
    dunningDateFrom: exists(resp, 'dunning_date_from')
      ? resp.dunning_date_from
      : '',
    dunningDateTo: exists(resp, 'dunning_date_to') ? resp.dunning_date_to : '',
    branchCodeFrom: exists(resp, 'branch_code_from')
      ? resp.branch_code_from
      : '',
    branchCodeTo: exists(resp, 'branch_code_to') ? resp.branch_code_to : '',
    radioBranchType: exists(resp, 'radio_branch_type')
      ? resp.radio_branch_type
      : '1',
    radioUserType: exists(resp, 'radio_user_type') ? resp.radio_user_type : '1',
    userCodeFrom: exists(resp, 'user_code_from') ? resp.user_code_from : '',
    userCodeTo: exists(resp, 'user_code_to') ? resp.user_code_to : '',
    radioUpdate: exists(resp, 'radio_update') ? resp.radio_update : '2',
    isOrderTelInclude: exists(resp, 'is_order_tel_include')
      ? resp.is_order_tel_include
      : false,
    isNotLostCollection: exists(resp, 'is_not_lost_collection')
      ? resp.is_not_lost_collection
      : false,
    isNotLostProcedure: exists(resp, 'is_not_lost_procedure')
      ? resp.is_not_lost_procedure
      : false,
    isRsvCollection: exists(resp, 'is_rsv_collection')
      ? resp.is_rsv_collection
      : false,
    isOtherDunningDoc: exists(resp, 'is_other_dunning_doc')
      ? resp.is_other_dunning_doc
      : false,
    isMailApplicant: exists(resp, 'is_mail_applicant')
      ? resp.is_mail_applicant
      : false,
    batchType: resp.batch_type
  }
}
